import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { CostingToolApiParameter, Result } from '@/interfaces/CostingToolApi';

type Dependencies = {
  http: {
    get: <Type>(url: string) => Promise<{ data: Type }>
    post: <Type>(url: string, payload?: unknown) => Promise<{ data: Type }>
  },
  errorHandler: (error: unknown) => void
}

export const buildCostingToolModule = (dependencies: Dependencies) => {
  const { http, errorHandler } = dependencies;

  @Module({ namespaced: true })
  class CostingToolModule extends VuexModule {
    private _results: any = {};

    dataIsLoading: boolean = false;

    get getDataIsLoading(): boolean {
      return this.dataIsLoading;
    }

    @Action
    public async loadDataFromCostingTool() {
      const scenario = this.context.rootGetters['scenario/getFields'];
      const apiParams: CostingToolApiParameter = {
        country: scenario.project.country,
        n_t_p: scenario.project.startDate,
        c_o_d: scenario.project.activityStartDate,
        project_total_power: scenario.pv.surfaceDefinition.pvPlantPower / 1000,
        structure_type: scenario.pv.surfaceDefinition.installationTypeRef
      };

      try {
        this.context.commit('setDataIsLoading', true);
        const { data } = await http.post<Result>(`/costingtool/costingtool_data`, apiParams);
        this.context.commit('setResult', data);
        this.context.commit('setDataIsLoading', false);
      } catch (error) {
        errorHandler(error);
      }
    }

    @Mutation
    private setDataIsLoading(bool: boolean) {
      this.dataIsLoading = bool;
    }

    @Mutation
    private setResult(data: Result) {
      this._results = data;
    }

    get result() {
      return this._results;
    }
  }

  return CostingToolModule;
};
